export const SINGLE_LINE_THRESHOLD_PX = 40
